// @ts-nocheck
export const downloadImage = async (source: string, name: string) => {
  const link = document.createElement('a');
  link.setAttribute('href', source);
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
};
